import FormValidation from "../../Validation/FormValidation";

const Texts = {

    init(form) {
        this.inputs = form.find('input[type="number"]');
        this.prepare(this.inputs);
        this.bind(this.inputs)
    },

    bind(inputs) {
        inputs.on('keyup change paste', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el), this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');
        const isNumber = input.is('[type="number"]');

        if (isNumber && isRequired) return !!input.val()
        else if (isRequired) return input.val().length >= 3
        else return true;
    },

    prepare(inputs) {

        const arrowUp = $('<div class="arrow up" direction="1"></div>');
        const arrowDown = $('<div class="arrow down" direction="-1"></div>');

        inputs.each((i, el) => {
            const input = $(el);
            const component = input.parent();
            arrowUp.clone().appendTo(component)
            arrowDown.clone().appendTo(component)

            const min = parseInt(input.attr('min'));
            const max = parseInt(input.attr('max'));
            const step = parseInt(input.attr('step')) || 1;

            component.find('.arrow').click((evt) => {
                const direction = parseInt($(evt.currentTarget).attr('direction'));
                const startVal = input.val() ? parseInt(input.val()) : 0;
                let value =  parseInt(input.val() || 0) + (direction * step)
                // console.log(startVal, direction , step, value)

                if(min !== undefined && value <= min) value = min;
                if(max !== undefined && value >= max) value = max;

                input.val(value);
            })
        })

    }
}

export default Texts;